import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormControl, Validators, FormGroup } from '@angular/forms';
import { environment } from 'environments/environment';
import ImageResize from 'quill-image-resize-module';
import * as QuillNamespace from 'quill';
import { DataService } from 'app/data.service';
import { MatSnackBar } from '@angular/material/snack-bar';
const Quill: any = QuillNamespace;

Quill.register('modules/imageResize', ImageResize);

@Component({
  selector: 'app-add-blog',
  templateUrl: './add-blog.component.html',
  styleUrls: ['./add-blog.component.css']
})
export class AddBlogComponent implements OnInit {

  uploadUrl = environment.api+'/api/blogs/addcontentimage'

  featured_image: any

  author_image: any

  featuredURL: any

  authorURL: any

  slug: any

  permalink: string

  url: string = environment.url + '/blog/'

  canShowPermalinkInput: boolean

  blog: FormGroup = new FormGroup({
    title: new FormControl('', [Validators.required]),
    body: new FormControl('', [Validators.required]),
    featuredImage: new FormControl(null),
    authorImage: new FormControl(null),
    slug: new FormControl('', [Validators.required]),
    authorName: new FormControl('', [Validators.required]),
    authorLink: new FormControl('', [Validators.required])
  })

  @ViewChild('quillFile', { static: true}) quillFileRef: ElementRef;
  quillFile: any;
  meQuillRef: any;
  editorModules = {
    toolbar: {
      container: [
        ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
        ['blockquote', 'code-block'],
        [{ 'header': 1 }, { 'header': 2 }],               // custom button values
        [{ 'list': 'ordered'}, { 'list': 'bullet' }],
        [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
        [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
        [{ 'direction': 'rtl' }],                         // text direction
        [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
        [{ 'color': [] }, { 'background': [] }],      
        [{ 'font': [] }],
        [{ 'align': [] }],
        ['clean'],                                         // remove formatting button
        ['link', 'image'],
      ],
      handlers: {
        image: (image) => {
          this.customImageUpload(image);
        }
      }
    },
    imageResize: true
  };

  constructor( private _superAdminService: DataService, private _router: Router
    , private _notification: MatSnackBar, private _route: ActivatedRoute ) { }

  ngOnInit() {
  }

  changeSlug(){
    this.slug = this.slug.toLowerCase().replace(/ /g,'-').replace(/[^\w-]+/g,'')
    this.blog['controls']['slug'].setValue(this.slug)
  }

  publish(){
    let post = this.blog.value
    this._superAdminService.submitBlog(post).subscribe( data => {
      if(data.status){
        this._router.navigate(['/admin/blog/edit/'+data.blog.id])
        this.openNotification('Successfully published!')
      }
    }, error => {
      if(error.error.message){
        this.openNotification(error.error.message)
      }
    })
  }

  saveAsDraft(){
    let post = this.blog.value
    this._superAdminService.submitDraft(post).subscribe( data => {
      if(data.status){
        this._router.navigate(['/admin/blog/edit/'+data.blog.id])
        this.openNotification('Successfully published!')
      }
    }, error => {
      if(error.error.message){
        this.openNotification(error.error.message)
      }
    })
  }

  changeSlugIfNot(){
    if(!this.slug && this.blog.value.title){
      let title = this.blog.value.title
      title = title.toLowerCase().replace(/ /g,'-').replace(/[^\w-]+/g,'')
      this.slug = title
      this.blog['controls']['slug'].setValue(this.slug)
    }
  }

  showPermalinkChangeOption(){
    this.canShowPermalinkInput = true
  }

  hidePermalinkChangeOption(){
    this.canShowPermalinkInput = false
  }

  getMeEditorInstance(editorInstance: any) {
    this.meQuillRef = editorInstance;
  }

  customImageUpload(image: any) {
    this.quillFileRef.nativeElement.click();
  }

  quillFileSelected(ev: any) {
    this.quillFile = ev.target.files[0];
    var filesize = Math.ceil((parseInt(this.quillFile.size)/1024)/1024)
    if(filesize <= 8){
      this._superAdminService.submitBlogImages(this.quillFile).subscribe(data=> {
        if(data.status){
          let link = data.link
          let range: any;
          const img = '<img class="img-within" src="' + link + '"></img>';
          range = this.meQuillRef.getSelection();
          this.meQuillRef.clipboard.dangerouslyPasteHTML(range.index, img);
        }
      });
    }else{
      this.openNotification('File size cannot exceed 8MB.')
    }
  }

  openNotification(message){
    this._notification.open( message, 'Cancel', {
      duration: 2000,
      horizontalPosition: 'right'
    })
  }

  featuredImageChangeEvent(event: any){
    this.featured_image = event.target.files[0]
    var filesize = Math.ceil((parseInt(this.featured_image.size)/1024)/1024)
    if(filesize <= 8){
      this.blog['controls']['featuredImage'].setValue(this.featured_image)
      var reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]); 
      reader.onload = (_event) => { 
        this.featuredURL = reader.result; 
      }
    }else{
      this.openNotification('File size cannot exceed 8MB.')
    }
  }

  authorImageChangeEvent(event: any){
    this.author_image = event.target.files[0]
    var filesize = Math.ceil((parseInt(this.author_image.size)/1024)/1024)
    if(filesize <= 8){
      this.blog['controls']['authorImage'].setValue(this.author_image)
      var reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]); 
      reader.onload = (_event) => { 
        this.authorURL = reader.result; 
      }
    }else{
      this.openNotification('File size cannot exceed 8MB.')
    }
  }

  maxLength(e){
    if(e.editor.getLength() > 10000){
      e.editor.deleteText(10000, e.editor.getLength())
    }
  }

}